let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2jp7n")).then(() => parcelRequire('h6cpN'));